<!--
<div class="card caret-red-500">

    <h1 class="text-primary-500">Impostazioni</h1>

    <div class="flex flex-col">
        <h2>Versione</h2>
        <div>{{version}}</div>

        
            <div class="card-primary tab-container my-4 py-2">
                <h2>Cache e dati</h2>

                <div class="flex justify-between border-b-2 border-primary-200 py-2">
                    <div class="flex flex-col mt-2">
                        <h3>Pulisci cache</h3>
                        <span class="mt-1">Pulisce la cache del browser per questa appilcazione, eseguire se non si
                            vedeno gli ultimi aggiornamenti</span>
                    </div>
                    <div class="flex items-center">
                        <button class="p-4 rounded-2xl bg-primary-50 hover:bg-primary-200 my-auto" (click)="clean()">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24"
                                stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M4 7l16 0" />
                                <path d="M10 11l0 6" />
                                <path d="M14 11l0 6" />
                                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="flex justify-between py-2">
                    <div class="flex flex-col mt-2">
                        <h3>Pulisci tutti i dati</h3>
                        <span class="mt-1">Pulisce tutti i dati del sito, <b>Attenzione: pulendo i dati verrà persa la
                                sessione e si dovrà rieffetuare il login</b></span>
                    </div>
                    <div class="flex items-center">
                        <button class="p-4 rounded-2xl bg-primary-50 hover:bg-primary-200 my-auto" (click)="cleanAll()">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24"
                                stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M4 7l16 0" />
                                <path d="M10 11l0 6" />
                                <path d="M14 11l0 6" />
                                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                            </svg>
                        </button>
                    </div>
                </div>

            </div>

        




    
            <div class="card-primary tab-container my-4 py-2 w-fit">
                <h2>Tema applicazione</h2>

                <div class="flex justify-between py-2">
                    <div class="flex flex-wrap items-center justify-center gap-4">
                        <button class="card-primary bg-slate-950/90 text-white flex flex-col justify-center items-center break-before-right w-40 h-40"
                            (click)="switchTheme(true)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="w-12 h-12">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path
                                    d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z" />
                                <path d="M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2" />
                                <path d="M19 11h2m-1 -1v2" />
                            </svg>
                            <p>Tema scuro</p>
                        </button>

                        <button class=" card-primary bg-white text-black flex flex-col justify-center items-center break-before-right w-40 h-40"
                            (click)="switchTheme(false)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="w-12 h-12">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                                <path d="M12 5l0 -2" />
                                <path d="M17 7l1.4 -1.4" />
                                <path d="M19 12l2 0" />
                                <path d="M17 17l1.4 1.4" />
                                <path d="M12 19l0 2" />
                                <path d="M7 17l-1.4 1.4" />
                                <path d="M6 12l-2 0" />
                                <path d="M7 7l-1.4 -1.4" />
                            </svg>
                            <p>Tema chiaro</p>
                        </button>

                        <button class="card-primary bg-background-dark flex flex-col justify-center items-center break-before-right w-40 h-40"
                            (click)="switchTheme()">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="w-12 h-12">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path
                                    d="M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10z" />
                                <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9" />
                                <path d="M16 9h2" />
                            </svg>
                            <p>Auto</p>
                        </button>

                    </div>



                </div>

            </div>

    



    </div>

    <div class="card-primary tab-container my-4 py-2" *ngIf="fuhrer">
        <h2>Storico email inviate</h2>

    </div>




    <app-custom-dialog #mailDialog id="mailDialog">


        <div class="flex flex-col m-2">
            <div class="bg-primary-200 p-4 rounded-2xl">
                <p class="font-medium">Email destinatario: {{visibleData?.recipient}}</p>
                <h4 class="font-medium"><span class="font-bold">Oggetto</span>: {{visibleData?.subject}}</h4>


                <div class="bg-primary-50 rounded-2xl mt-2 p-5">
                    <iframe srcdoc="{{visibleData?.body}}" width="100%" height="500px"></iframe>
                </div>

            </div>

        </div>
    </app-custom-dialog>

</div>
-->

<div @fadeInOutWithBlur class="flex flex-col items-center gap-2 p-2 card user-card rounded-3xl" *ngIf="ready">

    <app-custom-tabs [fields]="tabsFields"></app-custom-tabs>

    <!--     <div [@expandCollapseSidebar]="isMobile ? 'mobile' : sidebarOpen ? 'open' : 'closed'" [ngStyle]="{heigth: isMobile ? '0' : '80vh' }"
        class=" relative card-primary m-0 backdrop-blur-none p-2 w-full rounded-3xl {{isMobile ? 'flex flex-col' : ' flex justify-center items-center'}}">


        <div class="h-full w-full flex flex-col justify-between items-center gap-2">

            <div class="{{isMobile ? 'flex' : 'flex flex-col justify-start items-center'}}  w-full gap-2">

                <div class="flex w-full justify-start items-center p-2 rounded-2xl cursor-pointer hover:bg-primary-300 hover:text-primary-50  transition-all duration-300 {{pageName == 'memory' ? 'bg-primary-500 text-primary-50' : 'text-primary-600'}}"
                    (click)="navigateTo('memory')" tabindex="0">
                    <div class="flex w-16 items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 4l-8 4l8 4l8 -4l-8 -4" />
                            <path d="M4 12l8 4l8 -4" />
                            <path d="M4 16l8 4l8 -4" />
                        </svg>
                    </div>
                    <div @fadeInOutWithBlur class="flex items-center justify-center font-semibold" *ngIf="showText">
                        Memoria e cache
                    </div>
                </div>
            

                <div class="flex w-full justify-start items-center p-2 rounded-2xl cursor-pointer hover:bg-primary-300 hover:text-primary-50  transition-all duration-300 {{pageName == 'style' ? 'bg-primary-500 text-primary-50' : 'text-primary-600'}}"
                    (click)="navigateTo('style')" tabindex="0">
                    <div class="flex w-16 items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path
                                d="M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25" />
                            <path d="M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                        </svg>
                    </div>
                    <div @fadeInOutWithBlur class="flex items-center justify-center font-semibold" *ngIf="showText">
                        <p>Aspetto</p>
                    </div>
                </div>
        

                <div class="flex w-full justify-start items-center p-2 rounded-2xl cursor-pointer hover:bg-primary-300 hover:text-primary-50  transition-all duration-300 {{pageName == 'anagrafiche' ? 'bg-primary-500 text-primary-50' : 'text-primary-600'}}"
                    (click)="navigateTo('anagrafiche')" tabindex="0">
                    <div class="flex w-16 items-center justify-center">

                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                            <path d="M6 21v-2a4 4 0 0 1 4 -4h2.5" />
                            <path d="M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                            <path d="M19.001 15.5v1.5" />
                            <path d="M19.001 21v1.5" />
                            <path d="M22.032 17.25l-1.299 .75" />
                            <path d="M17.27 20l-1.3 .75" />
                            <path d="M15.97 17.25l1.3 .75" />
                            <path d="M20.733 20l1.3 .75" />
                        </svg>
                    </div>
                    <div @fadeInOutWithBlur class="flex items-center justify-center font-semibold" *ngIf="showText">
                        <p>Anagrafiche</p>
                    </div>
                </div>

                <div class="flex w-full justify-start items-center p-2 rounded-2xl cursor-pointer hover:bg-primary-300 hover:text-primary-50  transition-all duration-300 {{pageName == 'camera' ? 'bg-primary-500 text-primary-50' : 'text-primary-600'}}"
                    (click)="navigateTo('camera')" tabindex="0">
                    <div class="flex w-16 items-center justify-center">

                        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-12 h-12">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path
                                d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />
                            <path d="M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                        </svg>
                    </div>
                    <div @fadeInOutWithBlur class="flex items-center justify-center font-semibold" *ngIf="showText">
                        <p>Fotocamera</p>
                    </div>
                </div>


            </div>

            <div *ngIf="!isMobile" class="flex w-full justify-start items-center p-2 rounded-2xl cursor-pointer  hover:text-primary-50 text-primary-500  transition-all duration-300"
                tabindex="0" (click)="hideShow()">

                <div class="flex w-16 items-center justify-center" *ngIf="!sidebarOpen">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                        <path d="M9 4v16" />
                        <path d="M14 10l2 2l-2 2" />
                    </svg>
                </div>
                <div class="flex w-16 items-center justify-center" *ngIf="sidebarOpen">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                        <path d="M9 4v16" />
                        <path d="M15 10l-2 2l2 2" />
                    </svg>
                </div>


            </div>
        </div>


    </div> -->

    <div class="bg-none  m-0 w-full transition-all duration-300 {{isMobile ? '': 'p-4'}}" style="min-height: 80vh">

        <div class="text-text transition-all duration-300 shadow-sm  relative flex flex-col justify-center items-center ">


            <div class="h-full w-full">
                <router-outlet></router-outlet>
            </div>

        </div>
    </div>
</div>